// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"two-columns-block_subtitle__v2haz","wrapper":"two-columns-block_wrapper__u3cVs","slogan":"two-columns-block_slogan__6PyMp"};